import { sortBy } from 'lodash';
import React from 'react';
import { groupBySubject } from '../../../lib/measurement-group';
import Measurement from './Measurement';

interface MeasurementBySubjectProps {
  measurements: {
    subject: {
      id: string;
    };
    tracker: {
      id: string;
    };
    value: number;
  }[];
  subjects: {
    id: string;
    name: string;
  }[];
}

const MeasurementBySubject: React.FC<MeasurementBySubjectProps> = ({ measurements, subjects }) => {
  // Organize subjects by measurement. This will remove the subjects who have been added
  // to the note but not measured.
  const subjectsWithMeasurements = groupBySubject(measurements);

  // Figure out if there are any subjects without measurements
  const subjectsWithMeasurementsIds = subjectsWithMeasurements.map((g: { id: string }) => g.id);
  const subjectsWithoutMeasurements = subjects.filter(subject => {
    return !subjectsWithMeasurementsIds.includes(subject.id);
  });

  // Reconstitute all the subjects for render
  const allSubjects = [...subjectsWithMeasurements, ...subjectsWithoutMeasurements];

  return (
    <div className="mw6-l center">
      {allSubjects.map(subject => (
        <div key={subject.id} className="pb4" data-testid={`measurement-${subject.slug}`}>
          <h4 className="f4 fw6 mt0 mb3" data-testid="measurement-subject">
            {subject.name}
          </h4>
          {subject.measurements &&
            subject.measurements.length > 0 &&
            sortBy(subject.measurements, meas => meas.tracker.name).map(m => (
              <Measurement key={m.tracker.id} measurement={m} />
            ))}

          {!subject.measurements && (
            <div className="bt b--light-gray">
              <span className="db light-tan f7 i serif pv2">No measurements</span>
            </div>
          )}
        </div>
      ))}
      {allSubjects.length === 0 && <p className="f6 serif light-tan i mb0">No Data</p>}
    </div>
  );
};

export default MeasurementBySubject;
